var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-basis: 32%;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: 353px;\n  margin-bottom: 25px;\n  background: url(', ');\n  background-position: center;\n  background-size: cover;\n  box-shadow: 0 5px 10px 0 ', ';\n  transition: transform .2s ease-in-out;\n\n  @media (min-width: 768px) and (max-width: 1199px) {\n    flex-basis: 49%;\n  }\n\n  @media(max-width: 767px) {\n    flex-basis: 100%;\n  }\n'], ['\n  display: flex;\n  flex-basis: 32%;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: 353px;\n  margin-bottom: 25px;\n  background: url(', ');\n  background-position: center;\n  background-size: cover;\n  box-shadow: 0 5px 10px 0 ', ';\n  transition: transform .2s ease-in-out;\n\n  @media (min-width: 768px) and (max-width: 1199px) {\n    flex-basis: 49%;\n  }\n\n  @media(max-width: 767px) {\n    flex-basis: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  background: linear-gradient(0deg, ', ', ', ' 12%, ', ' 20%, ', ' 45%, ', ');\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  background: linear-gradient(0deg, ', ', ', ' 12%, ', ' 20%, ', ' 45%, ', ');\n  &:hover {\n    text-decoration: none;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  text-transform: uppercase;\n'], ['\n  font-family: ', ';\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  text-transform: uppercase;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1.25;\n  letter-spacing: -0.3px;\n  color: white;\n  margin: 0;\n'], ['\n  font-family: ', ';\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1.25;\n  letter-spacing: -0.3px;\n  color: white;\n  margin: 0;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';
var _Theme$colors = Theme.colors,
    primaryOpaque = _Theme$colors.primaryOpaque,
    primary = _Theme$colors.primary,
    primaryShadow = _Theme$colors.primaryShadow,
    primaryOpacity = _Theme$colors.primaryOpacity;
var _Theme$fonts = Theme.fonts,
    PlayfairDisplay = _Theme$fonts.PlayfairDisplay,
    Montserrat = _Theme$fonts.Montserrat;


export var TileWrapper = styled.div(_templateObject, function (props) {
  return props.img;
}, primaryShadow);

export var TextFrame = styled.a(_templateObject2, primary, primary, primaryOpacity, primaryOpaque, primaryOpaque);

export var Label = styled.p(_templateObject3, Montserrat);

export var Headline = styled.p(_templateObject4, PlayfairDisplay);

var TileComponent = function TileComponent(_ref) {
  var title = _ref.title,
      link = _ref.link,
      image = _ref.image,
      label = _ref.label;
  return React.createElement(
    TileWrapper,
    { img: image },
    React.createElement(
      TextFrame,
      { href: link },
      label ? React.createElement(
        Label,
        null,
        label
      ) : null,
      React.createElement(
        Headline,
        null,
        title
      )
    )
  );
};

TileComponent.displayName = 'TileComponent';

TileComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string
} : {};

export default TileComponent;